import { TextField } from '@mui/material'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

const PromoCodeField: FC = () => {
  const { t } = useTranslation()

  return (
    <TextField
      name="promo-code"
      placeholder={t('Promo code')}
      slotProps={{ htmlInput: { size: 16 }, input: { margin: 'none' } }}
    />
  )
}

export { PromoCodeField }
